import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

/**
 * Explainer shown when the user clicks "Take me there" on the domain-move
 * banner: the new domain asks for a one-time sign-in with their existing
 * login before anything else, so set that expectation before navigating.
 */
@Component({
  selector: 'app-wf-domain-move-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './domain-move-dialog.component.html',
})
export class WfDomainMoveDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WfDomainMoveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { targetUrl: string }
  ) {}

  goToNewDomain(): void {
    this.dialogRef.close();
    const target = this.safeTargetUrl();
    if (target) {
      window.location.href = target;
    }
  }

  // The banner only ever passes https://gotlivedata.com/... here, but dialog
  // data is runtime input: require https + the destination host so this can
  // never be repurposed as an open redirect.
  private safeTargetUrl(): string | null {
    try {
      const url = new URL(this.data.targetUrl);
      const onDestinationHost =
        url.hostname === 'gotlivedata.com' || url.hostname.endsWith('.gotlivedata.com');
      return url.protocol === 'https:' && onDestinationHost ? url.href : null;
    } catch {
      return null;
    }
  }
}
